export default __webpack_public_path__ + "static/media/photo--lg--94.fb08f724.jpg";